import { axiosClient } from "./axiosClient"

export const PAYMENT_PATH = '/api/v1/payment'

export const addPayment = (body) => {
    return axiosClient.post(PAYMENT_PATH, body)
}

export const updatePayment = (id, body) => {
    return axiosClient.put(`${PAYMENT_PATH}/${id}`, body)
}

export const deletePayment = (id) => {
    return axiosClient.delete(`${PAYMENT_PATH}/${id}`)
}

export const getPaymentById = (id) => {
    return axiosClient.get(`${PAYMENT_PATH}/${id}`)
}

export const getPagePayments = ({ search = '', lastId = '', id = "", partner = '' }) => {
    return axiosClient.get(`${PAYMENT_PATH}/page?search=${search}&lastId=${lastId}&id=${id}&partner=${partner}`)
}

export const uploadPaymentExcelFile = (body) => {
    return axiosClient.post(`${PAYMENT_PATH}/upload-excel`, body)
}